export function rainfallTotal(station) {
  const value = station?.rainfall?.total_mm
  return typeof value === 'number' && Number.isFinite(value) ? value : null
}

export function rainfallText(value) {
  return value == null ? 'nedostupné' : `${new Intl.NumberFormat('sk-SK', { maximumFractionDigits: 1 }).format(value)} mm`
}

export function rainfallColor(value) {
  if (value == null) return '#a5aaa5'
  if (value >= 20) return '#d9be4c'
  if (value >= 15) return '#89a947'
  if (value >= 10) return '#508271'
  return '#94aaa0'
}

export function rainfallRadius(value) {
  return 5 + Math.min(value ?? 0, 30) * .15
}
